// extracted by mini-css-extract-plugin
export default {"DragAndDropFile":"DragAndDropFile_DragAndDropFile__845Kl","dragOver":"DragAndDropFile_dragOver__JpAEA","dropped":"DragAndDropFile_dropped__NvdaZ"};